import {
    CacheType,
    createObservableDataAction,
    getCatalogId, IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICommerceApiSettings,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { generateCacheKey, getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { getProductUnitOfMeasureOptionsAsync } from './get-product-unit-of-measure-options.action';
import { UnitOfMeasureConversion } from '@msdyn365-commerce/retail-proxy';

export class GetUnitOfMeasureConversionsByIdInput implements IActionInput {
    public productId?: number;

    public channelId: number;

    public catalogId: number;

    private readonly apiSettings: ICommerceApiSettings;

    constructor(apiSettings: ICommerceApiSettings, productId?: number, catalogId?: number) {
        this.productId = productId;
        this.channelId = +apiSettings.channelId;
        this.catalogId = catalogId || 0;
        this.apiSettings = apiSettings;
    }

    public getCacheKey = () =>
        generateCacheKey(
            this.apiSettings,
            { key: 'Key', value: 'UnitOfMeasureConversionsID' },
            { key: 'ProductId', value: this.productId },
            { key: 'CatalogId', value: this.catalogId }
        );

    public getCacheObjectType = () => 'UnitOfMeasureConversions';

    public dataCacheType = (): CacheType => 'request';
}

export const createGetUnitOfMeasureConversionsByIdInput = (inputData: ICreateActionContext<IGeneric<IAny>>): GetUnitOfMeasureConversionsByIdInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    const catalogId = getCatalogId(inputData.requestContext);
    if (!productId) {
        throw new Error('Unable to create GetUnitOfMeasureConversionsByIdInput, no productId found on query');
    }
    return new GetUnitOfMeasureConversionsByIdInput(inputData.requestContext.apiSettings, parseInt(productId, 10), catalogId);
};

export async function getUnitOfMeasureConversionsByIdAction(input: GetUnitOfMeasureConversionsByIdInput, ctx: IActionContext): Promise<UnitOfMeasureConversion[]> {
    if (input.productId) {
        const results = await getProductUnitOfMeasureOptionsAsync({ callerContext: ctx }, [ input.productId ]);
        return results || [];
    }
    return [];
}

export const getUnitOfMeasureConversionsByIdDataAction = createObservableDataAction({
    id: 'dlvry/get-unit-of-measure-conversions-by-id',
    action: <IAction<UnitOfMeasureConversion[] | null>>getUnitOfMeasureConversionsByIdAction,
    input: createGetUnitOfMeasureConversionsByIdInput
});

export default getUnitOfMeasureConversionsByIdDataAction;
